import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  cleanUpDataFieldTemplate,
  cleanUpMessageTemplate,
  cleanUpTemplate,
  fetchDeleteTemplate,
  fetchGetFieldData,
  fetchGetTemplate,
  fetchGetUserProject,
  fetchPostTemplate,
  fetchPostWorkflow,
  fetchPutTemplate,
  fetchGetTemplateInteraction,
  fetchGetTemplateByProject
} from 'state-managament/template.slice';

export default function useTemplate(project) {
  const { fieldData, fieldDataConst, error, success, isLoaded, data, job } = useSelector((state) => state.template);

  const dispatch = useDispatch();

  const getFieldData = (args) => dispatch(fetchGetFieldData(args));
  const getUserProject = (args) => dispatch(fetchGetUserProject(args));
  const getTemplate = (args) => dispatch(fetchGetTemplate(args));
  const cleanUp = () => dispatch(cleanUpTemplate());
  const cleanUpMessage = () => dispatch(cleanUpMessageTemplate());
  const cleanUpDataField = () => dispatch(cleanUpDataFieldTemplate());

  const postTemplate = (args) => dispatch(fetchPostTemplate(args));
  const postWorkflow = (args) => dispatch(fetchPostWorkflow(args));

  const deleteTemplate = (args) => dispatch(fetchDeleteTemplate(args));
  const putTemplate = (args) => dispatch(fetchPutTemplate(args));
  const getTemplateInteraction = (args) => dispatch(fetchGetTemplateInteraction(args));
  const getTemplateByProject = (args) => dispatch(fetchGetTemplateByProject(args));

  useLayoutEffect(() => {
    // return () => cleanUpDataField();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    getFieldData,
    getUserProject,
    getTemplate,
    deleteTemplate,
    fieldData,
    fieldDataConst,
    postTemplate,
    postWorkflow,
    putTemplate,
    getTemplateInteraction,
    getTemplateByProject,
    error,
    success,
    isLoaded,
    data,
    job,
    cleanUp,
    cleanUpDataField,
    cleanUpMessage,
  };
}
